import React from 'react';
import { FaCertificate } from 'react-icons/fa';
import logoonly from '../assets/logoonly.svg';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header Section */}
      <section className="bg-[#000C66] text-white p-10 md:p-20">
        <h1 className="text-1xl md:text-3xl font-bold mb-4 relative inline-block">
          About us
          <span className="absolute left-0 bottom-0 w-full h-0.5 bg-white"></span>
        </h1>
        <p className="text-3xl md:text-1xl font-bold leading-relaxed">
          We create secure and transparent digital documents using blockchain technology. 
          Our platform ensures every document is verifiable, fostering trust and integrity in the digital age.
        </p>
      </section>

      {/* Content Section */}
      <section className="bg-white p-6 md:p-20 flex flex-col md:flex-row items-start md:items-center">
        <div className="md:w-1/2 mb-6 md:mb-0 md:mr-10">
          <div className="flex items-center mb-6">
            <FaCertificate className="text-6xl text-gray-800 mr-4" />
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800">TrustForge</h2>
          </div>
          <p className="text-gray-700 text-lg md:text-xl mb-4">
            We envision a future where digital documents are universally trusted and effortlessly verified. By integrating cutting-edge blockchain technology, TrustForge aims to foster a new era of digital integrity and security.
          </p>
          <p className="text-gray-700 text-lg md:text-xl">
            TrustForge is revolutionizing digital document management by providing a secure and transparent platform for document certification and verification. Our technology fosters trust and integrity, enabling users to confidently manage and share their digital documents in the digital age.
          </p>
        </div>
        <div className="md:w-1/2 flex justify-center md:justify-end mt-6 md:mt-0">
          <img
            src={logoonly}
            alt="logo"
            className="w-40 h-40 md:w-60 md:h-60"
          />
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
